import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDisableCheckInServiceMutation = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<number, void>({
    mutationFn: id => ApiInstance.post("/check_in/service/disable", { dealer_location_id: selectedLocation?.id, id }),
    onSuccess: id => {
      const locationServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.locationList);
      if (!locationServices) return;

      const serviceIdx = locationServices.findIndex(service => service.id === id);
      if (serviceIdx === -1) return;

      typedQueryClient.setQueryData(CheckInServicesQueryKeys.locationList, locationServices.toSpliced(serviceIdx, 1));
    }
  });
};
